<template>
  <div id="dw-s1" class="bmd-layout-drawer bg-faded position-fixed">
    <header>
      <a class="navbar-brand">{{empresa.nombre}}</a>
    </header>
    <ul class="list-group">
      <li class="border-bottom border-top"><a class="list-group-item botones-navegar" @click="navegar('categorias')">CATEGORIAS</a>
      </li>
      <li class="border-bottom"><a class="list-group-item botones-navegar" @click="navegar('contenido')">CONTENIDOS</a>
      </li>
      <li class="border-bottom"><a class="list-group-item botones-navegar" @click="navegar('estilo')"> CONFIGURACIÓN</a>
      </li>
      <li class="border-bottom" v-if="usuario.rol != 'regular'"><a class="list-group-item botones-navegar" @click="navegar('administrador')"> ADMINISTRADOR</a>  <!--v-if="usuario.rol != 'regular'"-->
      </li>
    </ul>
  </div>
</template>

<script>

  export default {
    name: "navegacionLateral",
    data() {
      return {
        empresa: {},
        usuario: {}
      }
    },
    created() {
      let self = this;
      EventBus.$on('empresa', function (cliente) {
        self.empresa = cliente;
      });

      EventBus.$on('usuario', function (usuario) {
        self.usuario = usuario;
      });
    },
    methods: {
      navegar: function (data) {
        EventBus.$emit('navegacion', data);
      }
    }
  }
</script>

<style scoped lang="scss">
  .botones-navegar {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/compartida/navegacionLateral.vue